










































































































































































import Vue from 'vue';
import {Component, Watch} from 'vue-property-decorator';
//@ts-ignore
import store from "../../store";
import {CatalogFilter, ContentPack, CurrentGame, Player} from "../../../types";
// @ts-ignore
import Tools from "../../helpers/Tools";
import EventApi from "../../api/EventsApi";
import CustomGameButton from "../Widgets/CustomGameButton.vue";
import GameCard from "../Widgets/GameCard.vue";
import MessageHelper from "../../helpers/MessageHelper";
import GameCatalogFilter from "./GameCatalogFilter.vue";
import AnalyticsApi from "../../api/AnalyticsApi";

@Component({
    components: {GameCatalogFilter, GameCard, CustomGameButton},
    props: {
        defaultGame: {
            type: Object,
            default: null,
            required: false
        },
        defaultPack: {
            type: Object,
            default: null,
            required: false
        }
    }
})

export default class GameCatalog extends Vue {
    private searchValue: string = '';
    private selectedGame: null|CurrentGame = null;
    private selectedPack: null|ContentPack = null;
    private packModel: string = '';
    private typeFilterModel: number = 0;
    private gameplayFilterModel: number = 0;
    private playersNumberFilterModel: number = 0;
    private ageFilterModel: number = 0;
    private durationFilterModel: string = '';
    private rulesAreVisible: boolean = false;
    private defaultGame!: CurrentGame|null;
    private defaultPack!: ContentPack|null;

    mounted(): void
    {
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'openCatalog'});
        if (this.defaultGame) {
            this.selectedGame = this.defaultGame;
        }
        if (this.defaultPack) {
            this.selectedPack = this.defaultPack;
            this.packModel = this.selectedPack ? this.selectedPack.name : '';
        }
    }

    beforeDestroy(): void
    {
        store.dispatch('setActiveGameplayCatalogFilter', 0);
        store.dispatch('setActiveTypeCatalogFilter', 0);
    }

    updated(): void
    {
        this.$nextTick(() => {
            this.updateScrolls();
        });
    }

    private get authorId(): string
    {
        return store.getters.getGameState.tasks.main.author;
    }

    private get author(): Player
    {
        return store.getters.getGameState.playersData[this.authorId];
    }

    /**
     * Статус подключения игрока (guest, active, pending)
     */
    private get playerConnectionStatus(): string
    {
        return store.getters.getPlayerConnectionStatus;
    }

    /**
     * Является гостем
     */
    private get isGuest(): boolean
    {
        return this.playerConnectionStatus === 'guest';
    }

    /**
     * Список пресетов
     * @private
     */
    private get presets(): Array<CurrentGame>
    {
        return store.getters.getActivitiesList;
    }

    /**
     * Первый пак
     */
    private get firstContentPack(): ContentPack|null
    {
        if (!this.selectedGame) {
            return null;
        }

        let contentPacks = this.selectedGame.contentPacks;
        for (let contentPackId in contentPacks) {
            return contentPacks[contentPackId]
        }

        return null;
    }

    /**
     * Отфильтрованные игры
     */
    private get filteredGames(): Array<CurrentGame>
    {
        return this.presets.reduce((games: Array<CurrentGame>, game: CurrentGame) => {
            Object.values(game.contentPacks).forEach((pack: ContentPack) => {
                if ((!this.searchValue.length || game.name.toUpperCase().includes(this.searchValue.toUpperCase()))
                    && (!this.gameplayFilterModel || pack.filters.includes(this.gameplayFilterModel))
                    && (!this.typeFilterModel || pack.filters.includes(this.typeFilterModel))
                    && (+game.settings.age >= +this.ageFilterModel)
                    && (!this.durationFilterModel.length || this.gameInDurationInterval(game))
                    && (!this.playersNumberFilterModel || this.gameInPlayersNumberInterval(game))) {
                    games.push(game);
                }
            });
            return Array.from(new Set(games));
        }, []);
    }

    /**
     * Метод для проверки входит ли продолжительность игры в выбранный фильтр
     * @param game
     * @private
     */
    private gameInDurationInterval(game: CurrentGame): boolean
    {
        const filterInterval: Array<string> = this.durationFilterModel.split('-');
        const gameInterval: Array<string> = game.settings.duration.split('-');

        const lowerFilterValue: number = typeof filterInterval[0] !== 'undefined' ? +filterInterval[0] : 0;
        const upperFilterValue: number = typeof filterInterval[1] !== 'undefined' ? +filterInterval[1] : 1000;

        const lowerGameValue: number = typeof gameInterval[0] !== 'undefined' ? +gameInterval[0] : 0;
        const upperGameValue: number = typeof gameInterval[1] !== 'undefined' ? +gameInterval[1] : lowerGameValue;

        return (lowerGameValue <= lowerFilterValue && upperGameValue >= lowerFilterValue)
            || (lowerGameValue >= lowerFilterValue && upperGameValue <= upperFilterValue);
    }

    /**
     * Метод для проверки входит ли кол-во игроков в выбранный фильтр
     * @param game
     * @private
     */
    private gameInPlayersNumberInterval(game: CurrentGame): boolean
    {
        const gameInterval: Array<string> = game.settings.numberOfPlayers.split('-');

        const lowerGameValue: number = typeof gameInterval[0] !== 'undefined' ? +gameInterval[0] : 1;
        const upperGameValue: number = typeof gameInterval[1] !== 'undefined' ? +gameInterval[1] : lowerGameValue;

        return lowerGameValue <= this.playersNumberFilterModel && upperGameValue >= this.playersNumberFilterModel;
    }

    /**
     * Закрыть модалку
     * @private
     */
    private closeModal(): void
    {
        this.$emit('close-modal');
    }

    /**
     * Выбрать пресет
     * @private
     */
    private selectPreset(activity: CurrentGame): void
    {
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});
        this.selectedGame = activity;
        this.selectedPack = this.firstContentPack;
        this.packModel = this.selectedPack ? this.selectedPack.name : '';
        (this.$refs.wrapper as HTMLElement).scrollTop = 0;
    }

    public setCurrentPack(activity: CurrentGame, pack: ContentPack): void
    {
        this.selectedGame = activity;
        this.selectedPack = pack;
        this.packModel = this.selectedPack ? this.selectedPack.name : '';
        (this.$refs.wrapper as HTMLElement).scrollTop = 0;
    }

    /**
     * Изменить пак
     */
    private changePack(pack: ContentPack): void
    {
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});
        this.selectedPack = pack;
        this.packModel = this.selectedPack ? this.selectedPack.name : '';
    }

    /**
     * Назад к списку игр
     * @private
     */
    private backToList(): void
    {
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});
        this.selectedGame = null;
    }

    private updateScrolls(): void
    {
        this.$nextTick(() => {
            if (typeof this.$refs.list !== 'undefined') {
                (this.$refs.list as HTMLElement).dispatchEvent(new CustomEvent('transitionend'));
            }
            if (typeof this.$refs.wrapper !== 'undefined') {
                (this.$refs.wrapper as HTMLElement).dispatchEvent(new CustomEvent('transitionend'));
            }
        });
    }

    /**
     * Получить ID видео
     * @param url
     * @private
     */
    private getYoutubeVideoId(url: string): string
    {
        return Tools.getYouTubeVideoId(url);
    }

    /**
     * Показать правила
     * @private
     */
    private showRules(): void
    {
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});
        this.rulesAreVisible = true;
    }

    /**
     * Скрыть правила
     * @private
     */
    private closeRules(): void
    {
        this.rulesAreVisible = false;
    }

    /**
     * Предложить игру
     * @private
     */
    private suggestGame(): void
    {
        if (!this.selectedPack || !this.selectedGame) {
            return;
        }

        MessageHelper.sendMessage('suggestTask', {
            packId: this.selectedPack.id,
            activityId: this.selectedGame.id,
        });

        this.closeModal();
    }

    /**
     * Запустить игру
     * @private
     */
    private startGame(): void
    {
        this.closeModal();

        if(!this.selectedPack || !this.selectedGame) {
            return;
        }
        const data = {
            contentPackId: this.selectedPack.id,
            setId: 1,
            activityId: this.selectedGame.id,
            newGame: true,

            selectedPack: this.selectedPack,
            selectedGame: this.selectedGame,
        };
        this.$emit('start-game', data);
        this.$analyticsApi.goal('start_game');
    }

    /**
     * Запуск песочницы
     * @private
     */
    private selectCustomGame(): void
    {
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});
        MessageHelper.sendMessage('startCustomGame', {});
        this.closeModal();
    }

    /**
     * Применить фильтр по типу
     * @param val
     * @private
     */
    private applyTypeFilter(val: number)
    {
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});
        this.typeFilterModel = val;
    }

    /**
     * Применить фильтр по геймплею
     * @param val
     * @private
     */
    private applyGameplayFilter(val: number)
    {
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});
        this.gameplayFilterModel = val;
    }

    /**
     * Применить фильтр по возрасту
     * @param val
     * @private
     */
    private applyAgeFilter(val: number)
    {
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});
        this.ageFilterModel = val;
    }

    /**
     * Применить фильтр по продолжительности игры
     * @param val
     * @private
     */
    private applyDurationFilter(val: string)
    {
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});
        this.durationFilterModel = val;
    }

    /**
     * Применить фильтр по продолжительности игры
     * @param val
     * @private
     */
    private applyPlayersNumberFilter(val: number)
    {
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});
        this.playersNumberFilterModel = val;
    }

    private resetFilters(): void
    {
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});
        this.typeFilterModel = 0;
        this.gameplayFilterModel = 0;
        this.playersNumberFilterModel = 0;
        this.ageFilterModel = 0;
        this.durationFilterModel = '';
        this.searchValue = '';
    }
}
